import * as React from 'react'
import ViewVehicleNav from './ViewVehicleNav'
import ViewVehicleRoute from './ViewVehicleRoute'
import { RouteComponentProps } from 'react-router'
import ButtonWithBtn from '../../ui/ButtonWithIcon'
import Edit from '../../icons/vehicle/Edit'
import Deactivate from '../../icons/vehicle/Deactivate'
import Activate from '../../icons/vehicle/Activate'
import { IMap, IProviderObject, IVehicleObj } from '../../../types'
import { Link } from 'react-router-dom'
import { IProviderProductObject } from '../../../types/provider-product'
import BackToList from 'src/components/ui/BackToList'

interface IViewVehicleProps extends RouteComponentProps<{ id: string }> {
  getVehicle: (id: string) => void
  fetchProductsByOrganizationId: (organizationId: string) => void
  deactivateVehicle: (vehicleId: string) => Promise<any>
  activateVehicle: (vehicleId: string) => Promise<any>
  organizationId: string
  vehicle: IVehicleObj
  providers: IMap<IProviderObject>
  providerProduct: IMap<IProviderProductObject>
}

class ViewVehicle extends React.Component<IViewVehicleProps> {
  constructor(props: any) {
    super(props)
  }

  public componentDidMount() {
    this.props.getVehicle(this.props.match.params.id)
    this.props.fetchProductsByOrganizationId(this.props.organizationId)
  }

  public render() {
    if (!this.props.vehicle) {
      return <div>Wait</div>
    }

    const vehicleId = this.props.vehicle.id

    return (
      <>
        <BackToList link='/vehicles' className='flex' />
        <div className='pt1 col-12 border-box'>
          <div className='px2 flex justify-between'>
            <div>
              <span className='h3 font-blue-grey'>{this.props.vehicle.model} </span>
              <span className='h5 ml2'>Fleet ID: {this.props.vehicle.fleetId}</span>
            </div>
            {this.props.vehicle.isActive ? (
              <div className='flex'>
                <Link to={this.redirectPath()}>
                  <ButtonWithBtn title={'Edit'}>
                    <Edit className='icon--small' />
                  </ButtonWithBtn>
                </Link>
                <div
                  className='cursor--pointer'
                  onClick={this.handleClickVehicle('/vehicles', vehicleId, this.props.deactivateVehicle)}
                >
                  <ButtonWithBtn title={'Deactivate'}>
                    <Deactivate className='icon--small' />
                  </ButtonWithBtn>
                </div>
              </div>
            ) : (
              <div className='flex ml-auto'>
                <div
                  className='cursor--pointer'
                  onClick={this.handleClickVehicle('/vehicles/deactivated', vehicleId, this.props.activateVehicle)}
                >
                  <ButtonWithBtn title={'Activate'}>
                    <Activate className='icon--small' />
                  </ButtonWithBtn>
                </div>
              </div>
            )}
          </div>

          <ViewVehicleNav
            currentPath={this.props.match.url}
            pathname={this.props.location.pathname}
            vehicleId={this.props.vehicle.id}
          />
          <ViewVehicleRoute
            path={this.props.match.url}
            vehicle={this.props.vehicle}
            providers={this.props.providers}
            providerProduct={this.props.providerProduct}
          />
        </div>
      </>
    )
  }

  private redirectPath = () => {
    // const { location } = this.props
    const { vehicle } = this.props

    if (/\/details/.test(window.location.pathname)) {
      return `/vehicles/edit/${vehicle.id}/details`
    } else if (/\/products/.test(window.location.pathname)) {
      return `/vehicles/edit/${vehicle.id}/products`
    } else if (/\/access-capacity/.test(window.location.pathname)) {
      return `/vehicles/edit/${vehicle.id}/access-capacity`
    } else if (/\/accommodations/.test(window.location.pathname)) {
      return `/vehicles/edit/${vehicle.id}/accommodations`
    }
    return window.location.pathname
  }

  private handleClickVehicle = (page: string, vehicleId: string, action: any) => () => {
    action(vehicleId)

    this.props.history.push(page)
  }
}

export default ViewVehicle



// WEBPACK FOOTER //
// ./src/components/vehicles/viewVehicle/ViewVehicle.tsx